export interface MasterSnak {
  name: string
  cognitiveAnchor: string
  emotionalPayoff: string
  coreVisual: string
  deckPage: string
  source: string
}

export const masterSnaks: MasterSnak[] = [
  {
    name: 'MoA',
    cognitiveAnchor: 'Mechanistic clarity',
    emotionalPayoff: 'Scientific confidence',
    coreVisual:
      'CD20 × CD3 bispecific mechanism diagram — binding + T-cell activation visual',
    deckPage: 'Deck p.8',
    source: 'Columvi 2L Core Sales Aid_V2 (3)[41].pdf',
  },
  {
    name: 'Survival',
    cognitiveAnchor: 'Curative potential',
    emotionalPayoff: 'Hope + impact',
    coreVisual:
      '3-year Overall Survival Kaplan–Meier curve — separation animation',
    deckPage: 'Deck p.15',
    source: 'Columvi 2L Core Sales Aid_V2 (3)[41].pdf',
  },
  {
    name: 'Disease control',
    cognitiveAnchor: 'Durability',
    emotionalPayoff: 'Predictability',
    coreVisual: 'Progression-Free Survival curve — durability highlight',
    deckPage: 'Deck p.19',
    source: 'Columvi 2L Core Sales Aid_V2 (3)[41].pdf',
  },
  {
    name: 'Depth of response',
    cognitiveAnchor: 'Strength of effect',
    emotionalPayoff: 'Clinical trust',
    coreVisual: 'Complete remission comparison chart — CR doubling animation',
    deckPage: 'Deck p.17',
    source: 'Columvi 2L Core Sales Aid_V2 (3)[51].pdf',
  },
  {
    name: 'Guidelines',
    cognitiveAnchor: 'External validation',
    emotionalPayoff: 'Practice confidence',
    coreVisual: 'EHA/ESMO treatment pathway graphic — recommendation highlight',
    deckPage: 'Deck p.22',
    source: 'Columvi 2L Core Sales Aid_V2 (3)[41].pdf',
  },
]
